<template>
    <div class="pages">
        <pageHeader></pageHeader>
        <div class="box">
            <div class="main">
                <acountNav></acountNav>
                <div class="acount-box">
                    <div class="acount-header">
                        <div class="acount-header-item" :class="index === headerIdx ? 'acount-header-item-active' : ''"
                            v-for="(item, index) in headerLists" :key="index">{{ item }}</div>
                    </div>
                    <div class="acount-main">
                        <div class="article-lists" v-if="collectionLists.length > 0">
                            <div class="article-item" v-for="(item, index) in collectionLists" :key="index">
                                <div class="title-box">
                                    <span class="column">#{{ item.tags[0] }}</span>
                                    <span class="title">{{ item.title }}</span>
                                </div>
                                <span class="time">{{ item.creationTime.split('T')[0] + ' ' + item.creationTime.split('T')[0] + ' ' + item.creationTime.split('T')[1].split('.')[0] }}</span>
                                <span class="content">{{ item.description }}</span>
                                <div class="footer-box">
                                    <span class="num">阅读 {{ item.cn }} · 评论 {{ item.pv }}</span>
                                </div>
                            </div>
                            <getMore @getMore="getMore" :state="getMoreState"></getMore>
                        </div>
                        <noData v-if="collectionLists.length === 0" title="暂无数据"></noData>
                    </div>
                </div>
            </div>
        </div>
        <pageFooter></pageFooter>
    </div>
</template>

<script>
import noData from '@/components/noData.vue'
import pageHeader from '@/components/pageHeader.vue'
import pageFooter from '@/components/pageFooter.vue'
import acountNav from '@/components/acountNav.vue'
import getMore from '@/components/getMore.vue'
import { getBuyLists } from '@/api/buy.js'
export default {
    name: "buyed",
    components: {
        pageHeader,
        pageFooter,
        acountNav,
        getMore,
        noData
    },
    data() {
        return {
            headerLists: ['文章'],
            // headerLists: ['文章', '课程'],
            headerIdx: 0,
            collectionLists: [],
            listsRequestdata: {
                page: 0,
                pageSize: 10,
                filter: {
                }
            },
            getMoreState: 'getMore',
            total:null
        }
    },
    created() {
        this.getBuyLists()
    },
    methods: {
        /**
         * 加载更多
         */
         getMore() {
            this.getMoreState = 'loading'
            setTimeout(() => {
                this.getBuyLists()
            }, 800)
        },
        /**
         * 获取收藏列表
         */
         getBuyLists() {
            if (this.total === this.collectionLists.length) {
                this.getMoreState = 'noMore'
                return
            }
            this.listsRequestdata.page++
            getBuyLists(this.listsRequestdata).then(res => {
                this.collectionLists = this.collectionLists.concat(res.items)
                this.total = res.totalCount
                if(res.items.length < this.listsRequestdata.pageSize){
                    this.getMoreState = 'noMore'
                }else{
                    this.getMoreState = 'getMore'
                }
            })
        }
    }
}
</script>

<style scoped>
.pages {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.box {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    min-height: calc(100vh - 120px);
    background-color: #F7F7F8;
}

.main {
    width: 1200px;
    min-height: calc(100vh - 120px);
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}

.acount-box {
    width: 888px;
    background-color: #ffffff;
    min-height: calc(100vh - 120px - 16px - 28px);
    margin-top: 16px;
    margin-bottom: 28px;
}

.acount-header {
    width: 888px;
    border-bottom: 1px solid #E8E8E8;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 18px;
}

.acount-header-item {
    height: 60px;
    margin-right: 70px;
    color: #000000;
    font-size: 16px;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.acount-header-item-active {
    position: relative;
    color: #DD0722;
}

.acount-header-item-active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #DD0722;
}

.acount-main {
    width: 888px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.article-lists {
    width: 888px;
    background-color: #ffffff;
}

.article-item {
    width: 848px;
    padding: 20px 0;
    margin: 0 20px;
    border-bottom: 1px solid #CDD2D9;
    cursor: pointer;
}

.article-item:last-child {
    border: none;
}

.article-item .title-box {
    display: flex;
    align-items: center;
}

.article-item .title-box span {
    font-size: 18px;
    margin-right: 8px;
    font-weight: bold;
}

.article-item .title-box .column {
    color: #4181B8;
}

.article-item .title-box .title {
    color: #06121E;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.article-item .time {
    color: #BCBCBC;
    font-size: 12px;
    margin-top: 6px;
}

.article-item .content {
    display: block;
    margin-top: 16px;
    font-size: 16px;
    color: #06121E;
}

.article-item .footer-box {
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.article-item .footer-box .num {
    font-size: 12px;
    color: #BCBCBC;
}

.article-item .footer-box img {
    width: 20px;
    height: 20px;
}

.study-lists {
    width: 888px;
    background-color: #ffffff;
}

.study-item {
    width: 848px;
    padding: 20px 0;
    margin: 0 20px;
    border-bottom: 1px solid #CDD2D9;
    cursor: pointer;
    display: flex;
    align-items: flex-start;
}

.study-item:last-child {
    border: none;
}

.study-item img {
    width: 210px;
    height: 120px;
    background-color: #8C9198;
    margin-right: 16px;
}

.study-item .study-item-right {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.study-item .study-item-right .title {
    font-size: 18px;
    color: #06121E;
    font-weight: bold;
}

.study-item .study-item-right .abstract {
    color: #999999;
    margin-top: 10px;
    font-size: 14px;
}

.study-item .study-item-right .time {
    color: #999999;
    font-size: 14px;
    margin-top: 40px;
}
</style>
